import { buildURL, fetchRequest } from 'Utils/api-fetch-request';

const KOL_VIDEOS_BASE_URL = '/api/videos/kol/';
const VIDEOS_BASE_URL = '/api/videos/';

interface FetchKolVideosParams {
    kolUuid: string;
    ordering: string;
    limit: number;
    offset: number;
}

export interface KolVideosResponse {
    count: number;
    results: Video[];
}

export interface Video {
    slug: string;
    thumbnail_small: string;
    thumbnail_large: string;
    duration: number;
    title: string;
    contributors: Author[];
    author: Author;
    created: string;
    views: number;
    brightcove_id: string;
    description: string;
    channel: Channel | null;
}

export interface Channel {
    author: Author;
    company: string;
    description: string;
    logo_large: string;
    other_admins: Author[];
    safety_information: string;
    slug: string;
    title: string;
}

export interface Author {
    avatar: string;
    company: string | null;
    date_joined: Date;
    first_name: string;
    last_name: string;
    position: string | null;
    site: { slug: string; text: string; display: string; root: boolean };
    title: string | null;
    uuid: string;
}

export interface ShareVideoParams {
    to: string[];
    message: string;
}

export async function fetchKolVideos({
    kolUuid,
    ordering,
    limit,
    offset,
}: FetchKolVideosParams): Promise<KolVideosResponse> {
    const url = buildURL(`${KOL_VIDEOS_BASE_URL}${kolUuid}/`, { ordering, limit, offset });
    return fetchRequest(url);
}

export async function thumbsupVideo(slug: string): Promise<void> {
    await fetchRequest(`${VIDEOS_BASE_URL}${slug}/thumbup/`, { method: 'POST' });
}

export async function removeThumbsupVideo(slug: string): Promise<void> {
    await fetchRequest(`${VIDEOS_BASE_URL}${slug}/thumbup/`, { method: 'DELETE' });
}

export async function bookmarkVideo(slug: string): Promise<void> {
    await fetchRequest(`${VIDEOS_BASE_URL}${slug}/bookmark/`, { method: 'POST' });
}

export async function removeBookmarkVideo(slug: string): Promise<void> {
    await fetchRequest(`${VIDEOS_BASE_URL}${slug}/bookmark/`, { method: 'DELETE' });
}

export async function trackLearnMoreClick(slug: string): Promise<void> {
    await fetchRequest(`/api/videos/${slug}/learn-more/`, { method: 'POST' });
}

export async function shareVideo(slug: string, { to, message }: ShareVideoParams): Promise<void> {
    await fetchRequest(`${VIDEOS_BASE_URL}${slug}/share/`, {
        method: 'POST',
        body: JSON.stringify({ to, message }),
    });
}
